// Decorative "connected circles" mark for the Groups landing (three friends + MAXx-blue).
const NODES = [
  { letter: "A", x: 110, y: 44, color: "#1684FF" },
  { letter: "M", x: 54, y: 132, color: "#35D7B0" },
  { letter: "J", x: 166, y: 132, color: "#8A6DFF" },
];

export function ConnectedCircles() {
  return (
    <svg width="200" height="180" viewBox="0 0 220 180" fill="none" aria-hidden="true">
      <g stroke="#294663" strokeWidth="1.5">
        <line x1="110" y1="44" x2="54" y2="132" />
        <line x1="110" y1="44" x2="166" y2="132" />
        <line x1="54" y1="132" x2="166" y2="132" />
      </g>
      {NODES.map((n) => (
        <g key={n.letter}>
          <circle cx={n.x} cy={n.y} r="32" fill="#0F2338" stroke={n.color} strokeWidth="2.5" />
          <text
            x={n.x}
            y={n.y}
            dy=".34em"
            textAnchor="middle"
            fill="#F7FAFF"
            fontFamily="Outfit, sans-serif"
            fontWeight="700"
            fontSize="22"
          >
            {n.letter}
          </text>
        </g>
      ))}
    </svg>
  );
}
